export default __webpack_public_path__ + "static/media/item-placeholder.897599e4.svg";